import * as RouterHandler from '../handlers/router-handler.js';

export function loadUrlLayout(url) {
    return RouterHandler.loadUrlLayout(url);
}
